<template>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h4 class="card-title text-purple">{{ $t('app.modules.product_catalog.title') }}</h4>

        <div class="row">
          <div class="col-3">
            <div class="row">
              <div class="col-12">

                <div v-for="cat in categories">

                  <div class="card" v-if="cat.subcategorias != null">
                    <div class="card-body collapse_cat">
                      <el-collapse accordion>
                        <el-collapse-item name="1" :title="cat.nombreCategoria" class="col-12">

                          <div class="row card_option" v-for="sub in cat.subcategorias" :class="optionSelected(cat.idCategoriaProducto, sub.idSubcategoriaProducto)"
                               @click="selectOption(cat.idCategoriaProducto, sub.idSubcategoriaProducto)">
                            <div class="col-1"></div>
                            <div class="col-11">
                              <label :class="optionSelected(cat.idCategoriaProducto, sub.idSubcategoriaProducto)">{{ sub.nombreSubcategoria }}</label>
                            </div>
                          </div>

                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                  <div v-else class="card card_option" :class="optionSelected(cat.idCategoriaProducto, 0)" @click="selectOption(cat.idCategoriaProducto, 0)">
                    <div class="card-body">
                      <label :class="optionSelected(cat.idCategoriaProducto, 0)">{{ cat.nombreCategoria }}</label>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div class="col-9">

            <div class="row">

              <div class="col-4" v-for="item in familiaProductos">
                <card-familia-producto
                  :iconografia="item.iconografia"
                  :title="item.productoPadre"
                  :description="item.traducciones[0].descripcion"
                  :idFamilia = "item.idFamiliaProducto"
                />
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getResponse} from "@/util/utilities";

export default {
  name: "catalogoProductos",
  components: {
    CardFamiliaProducto: () => import("./cardFamiliaProducto")
  },
  data(){
    return {
      categories: [],
      idCategoria: 0,
      idSubcategoria: 0,
      familiaProductos: [],
      payload: {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0,
        withCategories: true,
        CategoriaProducto_idCategoriaProducto: 0,
        SubcategoriaProducto_idSubcategoriaProducto: 0,
        onlyActives: true
      }
    }
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    async loadCategories(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      }).then(null);

      let request = await this.$http.post(route("CategoriaProducto/getCategoria"), this.payload);
      let response = getResponse(request, null);

      if(response != null){
        this.categories = response.categoriaProducto;

        if(this.categories.length > 0){
          this.idCategoria = this.categories[0].idCategoriaProducto;
          this.idSubcategoria = this.categories[0].subcategorias != null ? this.categories[0].subcategorias[0].idSubcategoriaProducto : 0;

          this.loadFamilia();
        }
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
      this.$swal.close();
    },
    async loadFamilia(){
      this.payload.CategoriaProducto_idCategoriaProducto = this.idCategoria;
      this.payload.SubcategoriaProducto_idSubcategoriaProducto = this.idSubcategoria;
      this.payload.OnlyPublish = true;

      let fp_request = await this.$http.put(route("FamiliasProducto/getFamiliaProductoByCategoria"), this.payload);
      let fp_response = getResponse(fp_request, null);

      if(fp_response != null){
        this.familiaProductos = fp_response.familiasProductos;
      }
    },
    optionSelected(idCategoria, idSubcategoria) {

      if(this.idCategoria === idCategoria){
        if(idSubcategoria === 0){
          return 'select';
        }
        else if(this.idSubcategoria === idSubcategoria){
          return 'subselect';
        }
      }
      return '';
    },
    selectOption(idCategoria, idSubcategoria){
      this.idCategoria = idCategoria;
      this.idSubcategoria = idSubcategoria;
      this.loadFamilia();
    }
  }
}
</script>

<style>
.el-collapse-item__wrap {
  border-bottom: 0 !important;
}
.el-collapse-item__header {
  border-bottom: 0 !important;
  font-weight: bold !important;
}
.el-collapse-item:last-child {
  margin-bottom: 0 !important;
}
.el-collapse-item__arrow.el-icon-arrow-right {
  font-weight: bold !important;
}
.icon-img {
  width: 60% !important;
  border-radius: 10px !important;
}
</style>

<style scoped>
.card {
  border-radius: 12px !important;
}
.card_option {
  margin-bottom: 5px;
  cursor: pointer;
}
.card_option > div > label {
  cursor: pointer !important;
  color: #303133;
  font-weight: bold;
}

.card_option.select {
  background-color: red !important;
}
.card_option.select > div.card-body  {
  background-color: white !important;
  border-radius: 0 10px 10px 0 !important;
  margin-left: 6px;
}
.card-body.collapse_cat {
  padding: 0 !important;
}
.select {
  color: red !important;
}
.subselect {
  color: red !important;
}
.el-collapse {
  border-top: 0 !important;
  border-bottom: 0 !important;
}



</style>
